export default "__VITE_ASSET__CchewYzl__"